import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 border-t border-secondary-800">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-read-line text-2xl text-accent-400"></i>
                </div>
                <span className="text-xl font-bold font-heading text-background-50">韩漫网</span>
              </div>
              <p className="text-secondary-400 text-sm leading-relaxed max-w-md">
                韩漫网致力于为中文读者提供最优质的韩国漫画在线阅读体验。我们精心挑选各类热门韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型，让每一位漫画爱好者都能在这里找到心仪的作品。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-bold font-heading mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/category/romance" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">恋爱漫画</Link>
                </li>
                <li>
                  <Link to="/category/fantasy" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">奇幻冒险</Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">热血动作</Link>
                </li>
                <li>
                  <Link to="/about" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-background-50 font-bold font-heading mb-4">热门分类</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/category/thriller" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">悬疑惊悚</Link>
                </li>
                <li>
                  <Link to="/category/comedy" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">搞笑日常</Link>
                </li>
                <li>
                  <Link to="/category/drama" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">剧情人生</Link>
                </li>
                <li>
                  <Link to="/category/bl" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">BL漫画</Link>
                </li>
                <li>
                  <Link to="/category/completed" className="text-secondary-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap">已完结</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-secondary-500 text-xs">
              &copy; 2026 韩漫网 ManHuaKR.com - 免费韩国漫画在线阅读平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors text-xs whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors text-xs whitespace-nowrap">使用条款</a>
              <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors text-xs whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}